import React from "react";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";
import "./Estrutura.css";

const ambientes = [
  {
    titulo: "Musculação",
    texto:
      "Halteres, racks e máquinas para treinos de força do básico ao avançado.",
    img: "/assets/estrutura/musculacao.jpg",
  },
  {
    titulo: "Quiropraxia",
    texto:
      "Atendimento especializado em ajustes articulares, alívio de dor e melhora da mobilidade, com avaliação postural.",
    img: "/assets/estrutura/quiropraxia.jpg",
  },
  {
    titulo: "Sala de Poses",
    texto:
      "Espaço com espelhos amplos e iluminação cênica para prática de poses, checagens de simetria e apresentações.",
    img: "/assets/estrutura/sala-poses.jpg",
  },
  {
    titulo: "Área Social",
    texto:
      "Área para descanso e convivência, com um ambiente convidativo pós/Pré-treino.",
    img: "/assets/estrutura/area-social.jpg",
  },
];

const Estrutura = () => {
  return (
    <>
      <Header2 />

      <main className="gym">
        {/* HERO */}
        <section className="hero">
          <div
            className="hero__bg"
            style={{ backgroundImage: `url("/assets/estrutura/fundo.jpg")` }}
            role="img"
            aria-label="Área de musculação moderna com equipamentos"
          ></div>
          <div className="hero__overlay" />
          <div className="hero__content container">
            <h1 className="hero__title">ESTRUTURA</h1>
            <p className="hero__subtitle">
              Ambientes pensados para performance: musculação, cardio, treino operacional e recuperação.
            </p>
          </div>
        </section>

        {/* AMENITIES */}
        <section className="amenities container" aria-label="Amenidades e destaques">
          <ul className="amenities__list">
            <li className="chip">Musculação</li>
            <li className="chip">Quiropraxia</li>
            <li className="chip">Sala de Poses</li>
            <li className="chip">Área Social</li>
          </ul>
        </section>

        {/* GRID DE AMBIENTES */}
        <section className="zones-grid container" aria-label="Ambientes da academia">
          {ambientes.map((a, i) => (
            <article key={i} className="zone-card">
              <div
                className="zone-card__media"
                style={{
                  backgroundImage: `url(${a.img})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
              <div className="zone-card__content">
                <h3 className="zone-card__title">{a.titulo}</h3>
                <p className="zone-card__text">{a.texto}</p>
              </div>
            </article>
          ))}
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Estrutura;
